const config = {
  siteUrl: 'http://www.coolfood.net'
}

export default config;